import { useEffect, useState } from "react";

/**
 * A reusable Bootstrap radio group.
 * Props:
 *  - name   : string   (shared name for the <input>s)
 *  - options: array    (each { value, label })
 *  - inline : boolean  (if true, show horizontally)
 *  - onChange: function(value)  (called when selection changes)
 */
export default ({ name, options, inline, onChange,defaultSelected='' })=> {
  const [selected, setSelected] = useState("");
  useEffect(()=>{
  setSelected(defaultSelected);
  },[])

  const handleChange = (e) => {
    setSelected(e.target.value);
    onChange?.(e.target.value);
  };

  return (
    <div 
          className={`d-flex`}>
      {options.map(({ value, label }) => (
        <div
        style={{
            marginRight:10
          }}
        className="pr-4"
          key={value}
        >
          <input
            type="radio"
            name={name}
            id={`${name}-${value}`}
            value={value}
            checked={selected === value}
            onChange={handleChange}
          />
          <label style={{
            marginLeft:6
          }} htmlFor={`${name}-${value}`}>
            {label}
          </label>
        </div>
      ))}
    </div>
  );
}
